import React from 'react';
import { Rectangle } from 'recharts';

// Componente para criar um cursor discreto, arredondado e ligeiramente maior que a barra
const CustomBarCursor = (props) => {
    const { x, y, width, height } = props;

    const newHeight = height + 10;
    
    const newY = y - 5; 

    return (
        <Rectangle
            fill="rgba(255, 255, 255, 0.05)"
            stroke="none"
            x={x}
            y={newY} 
            width={width}
            height={newHeight} 
            // BORDAS ARREDONDADAS
            radius={[8, 8, 8, 8]} 
        />
    );
};

export default CustomBarCursor;